import React from "react"
import { PropTypes } from "prop-types"
import AddressHelper from "../../common/helpers/address_helper"
import "./Access.scss"
import { googleApiKey } from "../../common/constants/serialized"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"

export class Access extends React.Component {
  componentDidMount() {
    const mapContainer = this.refs.mapContainer
    if (mapContainer) {
      const mapContainerRect = mapContainer.getBoundingClientRect()
      this.setState({
        mapContainerWidth: mapContainerRect.width
      })
    }
  }

  get mapContainerWidth() {
    return this.state ? this.state.mapContainerWidth : null
  }

  get mapWidth() {
    return this.mapContainerWidth
      ? Math.floor(this.state.mapContainerWidth)
      : null
  }

  get mapHeight() {
    return this.shouldShowMap ? Math.floor((this.mapWidth * 9) / 16) : null
  }

  get shouldShowMap() {
    return !!this.mapWidth
  }

  get mapImageUrl() {
    return [
      `https://maps.googleapis.com/maps/api/staticmap?key=${googleApiKey}`,
      `&center=${this.props.lat},${this.props.lon}`,
      `&zoom=14`,
      `&size=${this.mapWidth}x${this.mapHeight}`,
      `&maptype=roadmap`,
      `&markers=color:red%7C${this.props.lat},${this.props.lon}`,
      `&language=${document.documentElement.lang || "ja"}`,
      `&scale=2`
    ].join("")
  }

  get googleMapsUrl() {
    return `https://www.google.com/maps/place/${this.props.lat},${this.props.lon}/@${this.props.lat},${this.props.lon},14z`
  }

  get hasAddress() {
    return this.props && !!this.props.prefecture
  }

  render() {
    const { t } = this.props
    return (
      <section id="access" className="listing-access">
        <h2>{t("navigation.access")}</h2>
        <p>
          <span id="address-text" style={{ marginRight: 4 }}>
            {AddressHelper.address(
              this.props.prefecture,
              this.props.city,
              this.props.street_address,
              this.props.apt_name,
              this.props.lang,
              this.props.country_code,
              this.props.country
            )}
          </span>
          {this.hasAddress &&
            <a
              href={this.googleMapsUrl}
              className="bl-link m-text"
              target="_blank"
              rel="noopener"
            >
              {t("access.googlemap")}
            </a>
          }
        </p>
        <div
          className="n-map-wrap notranslate map-container"
          ref="mapContainer"
        >
          {this.shouldShowMap &&
            <img className="map-image" src={this.mapImageUrl} />
          }
        </div>
      </section>
    )
  }
}

Access.propTypes = {
  lang: PropTypes.string.isRequired,
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  prefecture: PropTypes.object.isRequired,
  city: PropTypes.object.isRequired,
  street_address: PropTypes.object.isRequired,
  apt_name: PropTypes.object.isRequired,
  country_code: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired
}

Access.defaultProps = {
  lang: "",
  lat: 0,
  lng: 0,
  prefecture: {},
  city: {},
  street_address: {},
  apt_name: {}
}

export default compose(withNamespaces("listings"))(Access)
